import {
    TOGGLE_MENU,
    CLEAR_COMPANY,
    CLEAR_LOYALTY_PROGRAM,
    CLEAR_RESTAURANT,
    NEW_PANEL_VERSION_DETECTED,
    FETCH_META,
    FETCH_COMMON_IMAGES,
    CHANGE_LANGUAGE
} from './types';
import api from './api';
import i18next from 'i18next';

export const toggleMenu = () => {
    return {
        type: TOGGLE_MENU
    };
};

export const clearRestaurant = () => {
    return {
        type: CLEAR_RESTAURANT
    };
};

export const clearCompany = () => {
    return {
        type: CLEAR_COMPANY
    };
};

export const clearLoyaltyProgram = () => {
    return {
        type: CLEAR_LOYALTY_PROGRAM
    };
};

export const newPanelVersionDetected = version => {
    return {
        type: NEW_PANEL_VERSION_DETECTED,
        payload: version
    };
};

export const fetchMeta = () => {
    return {
        type: FETCH_META,
        payload: api.meta.get(),
        meta: { preventLoading: true }
    };
};

export const fetchCommonImages = () => {
    return {
        type: FETCH_COMMON_IMAGES,
        payload: api.images.getCommon(),
    };
};

export const uploadCommonImage = (file, mode) => {
    const data = new FormData();
    data.append('file', file);
    data.append('name', file.name);

    return {
        type: FETCH_COMMON_IMAGES,
        payload: api.images.uploadCommon(data, mode),
        meta: { toastSuccess: true, dispatchOnSuccess: fetchCommonImages }
    };
};

export const changeLanguage = (lang, force = false) => {
    return dispatch => {
        if (force || lang !== i18next.language) {
            i18next.changeLanguage(lang).then(() => {
                localStorage.setItem('language', lang);
                document.body.setAttribute('dir', i18next.dir(lang));
                dispatch({ type: CHANGE_LANGUAGE, payload: lang });
            });
        }
    };
};